import { defineComponent } from '@vue/composition-api';
import { PaginationSelect } from '@/components/Inputs';
import TablePaginationV2 from '@/views/_components/Table/TablePaginationV2.vue';
export default defineComponent({
    name: 'TableFooter',
    components: {
        PaginationSelect,
        TablePaginationV2,
    },
    props: {
        query: {
            type: Object,
            required: true,
        },
        activePage: {
            type: Number,
            required: true,
        },
        totalCount: {
            type: Number,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        dataNotEmpty: {
            type: Boolean,
            default: false,
        },
    },
});
